enum CartTotalLabelEnum {
    SUBTOTAL = "Subtotal",
    SHIPPING = "Shipping",
    DISCOUNT = "Discount",
    TAX = "Tax",
    GRAND = "Total",
}

export default CartTotalLabelEnum;
